import { render, staticRenderFns } from "./top-things-to-do-in-wasaga-this-winter.vue?vue&type=template&id=03494696&"
import script from "./top-things-to-do-in-wasaga-this-winter.vue?vue&type=script&lang=js&"
export * from "./top-things-to-do-in-wasaga-this-winter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports